export default {
  readers: [
    'ABCReaders',
    'Admin'
  ]
}
